import { ActionPermission } from '../../constants';
import type { ActionPermissionType } from '../../types';

const CHECK_ACTION_DEPENDENCIES = {
  [ActionPermission.VIEW]: [],
  [ActionPermission.UPDATE]: [ActionPermission.VIEW],
  [ActionPermission.CREATE]: [ActionPermission.VIEW, ActionPermission.UPDATE],
  [ActionPermission.STATUS]: [ActionPermission.VIEW],
  [ActionPermission.DELETE]: [ActionPermission.VIEW],
};
export function autoCheckAction(action: ActionPermissionType) {
  return CHECK_ACTION_DEPENDENCIES[action];
}
